module.exports = __webpack_public_path__ + "images/krankenzusatzversicherung.png?26e8bb467703f6bbabbd8927f646676a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/krankenzusatzversicherung.png
// module id = 0Y14
// module chunks = 0